import Error from '../model/Error';
import axios from 'axios';

export default class IsbjFederationConfigRepository {
    static find(federationId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/federations/${federationId}/isbj/config`)
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static update(federationId, data) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/federations/${federationId}/isbj/config`, {
                    certificatePassword: data.certificatePassword,
                    hmacUsername: data.hmacUsername,
                    hmacKey: data.hmacKey,
                })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
